import { SVGPureIcon } from '@ui/svg-icon';
import globalStore from '@/store/global';
import { Button } from 'antd';
import agentPageStore from '@/pages/agent-home/store';
import { HelpOther } from '@/common/helper';

const Header = ({ store, form, id, server_id }) => {
  return (
    <div className="flex items-center justify-between h-72px leading-72px box-border pl-24px pr-20px  text-16px font-medium text-[#000] border-b-1px border-b-[rgba(0,0,0,0.10)]">
      <div
        className="flex items-center cursor-pointer"
        onClick={() => {
          if (server_id) {
            globalStore.navigate('/tools/aiagent/mcpsquare');
          } else {
            globalStore.navigate('/tools/aiagent')
          }
        }}
      >
        <SVGPureIcon className="cursor-pointer" size={24} name="back" />

        <span className='ml-12px'>返回</span>
      </div>
      <div className="ml-16px">{!id ? '创建' : '编辑'}智能体</div>

      <div className="flex items-center gap-16px">
        {id ? (
          <div>
            <Button
              onClick={() => {
                HelpOther.confirm({
                  title: '删除智能体',
                  okText: '删除',
                  content: (
                    <div className="whitespace-nowrap">
                      确定要删除该智能体吗？
                    </div>
                  ),
                  onOk: () => {
                    agentPageStore.deleteAgent(id, store.agent_type, () => {
                      globalStore.goBack();
                    });
                  },
                });
              }}
              loading={store.sunmitLoading}
              className=" delete-btn !w-100px !h-36px"
              type="primary"
              htmlType="submit"
            >
              删除
            </Button>
          </div>
        ) : null}
        <Button
          onClick={() => {
            form.submit();
          }}
          loading={store.sunmitLoading}
          className="wcp-btn !w-100px !h-36px"
          type="primary"
          htmlType="submit"
        >
          发布
        </Button>
      </div>
    </div>
  );
};

export default Header;
